import { render } from "./KPIsChart.vue?vue&type=template&id=8e074470&scoped=true"
import script from "./KPIsChart.vue?vue&type=script&lang=js"
export * from "./KPIsChart.vue?vue&type=script&lang=js"

import "./KPIsChart.vue?vue&type=style&index=0&id=8e074470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e074470"]])

export default __exports__